import {createRouter, createWebHistory} from 'vue-router';
import AuthLayout from './components/layouts/AuthLayout.vue';
import DefaultLayout from './components/layouts/DefaultLayout.vue';
import Page404 from './views/PageNotFound.vue';
import Login from './views/auth/Login.vue';
import Dashboard from '@/views/Dashboard.vue';
import ContractOverview from '@/views/ContractOverview.vue';
import ContractStrategyOverview from '@/views/ContractStrategyOverview.vue';
import ServiceRequirements from '@/views/ServiceRequirements.vue';
import ServiceRequirementsHistory from '@/views/service-requirements/ServiceRequirementsHistory.vue';
import ServiceRequirementDetail from '@/views/service-requirements/ServiceRequirementDetail.vue';
import ClientServiceRequirementsIndex from '@/views/service-requirements/ClientServiceRequirementsIndex.vue';
import ClientServiceRequirementDetail from '@/views/service-requirements/ClientServiceRequirementDetail.vue';
import BackOfficeServiceRequirementsIndex from '@/views/service-requirements/BackOfficeServiceRequirementsIndex.vue';
import AdvisorServiceRequirementsIndex from '@/views/service-requirements/AdvisorServiceRequirementsIndex.vue';
import Settings from '@/views/Settings.vue';
import NotificationSettings from '@/views/NotificationSettings.vue';
import Notifications from '@/views/Notifications.vue';
import Activation from '@/views/auth/Activation.vue';
import DocumentsIndex from '@/views/documents/DocumentsIndex.vue';
import DocumentTemplatesIndex from '@/views/document-templates/DocumentTemplatesIndex.vue';
import DocumentsDetail from '@/views/documents/DocumentsDetail.vue';
import MyDocuments from '@/views/documents/MyDocumentsIndex.vue';
import DocumentTemplateDetail from '@/views/document-templates/DocumentTemplateDetail.vue';
import PdfViewer from '@/components/pdf-viewer/PdfViewer.vue';
import ClientsIndex from '@/views/clients/ClientsIndex.vue';
import ClientsDetail from '@/views/clients/ClientsDetail.vue';
import ClientsArchive from '@/views/clients/ClientsArchive.vue';
import ResetPassword from '@/views/auth/ResetPassword.vue';
import ForgottenPassword from '@/views/auth/ForgottenPassword.vue';
import FileDetail from '@/views/files/FileDetail.vue';
import DocumentTemplateCategoriesIndex from '@/views/document-template-categories/DocumentTemplateCategoriesIndex.vue';
import DocumentsDetailSimple from '@/views/documents/DocumentsDetailSimple.vue';
import UsersIndex from '@/views/users/UsersIndex.vue';
import UsersDetail from '@/views/users/UsersDetail.vue';
import FormsTemplatesIndex from '@/views/forms-templates/FormsTemplatesIndex.vue';
import IntermediariesIndex from '@/views/intermediaries/IntermediariesIndex.vue';
import IntermediariesDetail from '@/views/intermediaries/IntermediariesDetail.vue';
import IntermediaryPeopleIndex from '@/views/intermediary-people/IntermediaryPeopleIndex.vue';
import IntermediaryPeopleDetail from '@/views/intermediary-people/IntermediaryPeopleDetail.vue';
import MyAdvisorsIndex from '@/views/intermediary-people/MyAdvisorsIndex.vue';
import PaymentTerms from '@/views/PaymentTerms.vue';
import StrategiesIndex from '@/views/strategies/StrategiesIndex.vue';
import StrategiesDetail from '@/views/strategies/StrategiesDetail.vue';
import BondsIndex from '@/views/bonds/BondsIndex.vue';
import BondsDetail from '@/views/bonds/BondsDetail.vue';
import ClientBondsIndex from '@/views/bonds/ClientBondsIndex.vue';
import ClientBondDetail from '@/views/bonds/ClientBondDetail.vue';
import AdvisorBondsIndex from '@/views/bonds/AdvisorBondsIndex.vue';
import ContractTypesIndex from '@/views/contract-types/ContractTypesIndex.vue';
import ContractTypesDetail from '@/views/contract-types/ContractTypesDetail.vue';
import ReportsIndex from '@/views/reports/ReportsIndex.vue';
import {getApiBaseUrl, getFrontendBase} from '@/helper';
import SelfRegister from '@/views/auth/SelfRegister.vue';
import BatchesIndex from "@/views/upload-reports/BatchesIndex.vue";
import BatchesDetail from "@/views/upload-reports/BatchesDetail.vue";

const routes = [
    {
        path: '/',
        redirect: '/home',
        component: DefaultLayout,
        children: [
            {path: '/home', name: 'Dashboard', component: Dashboard, meta: {title: 'Nástěnka'}},
            {path: '/service-requirements/create', name: 'ServiceRequirementsCreate', component: ServiceRequirements, meta: {title: 'Servisní požadavky'}},
            // Zakomentováno: umožňovalo otevřít existující požadavek k "úpravě" ve formuláři
            // ServiceRequirements.vue, který ale text tiše přepisoval bez zachování historie
            // a bez ověření vlastnictví. Tlačítko "Usporiadať" na dashboardu teď vede na
            // /my-service-requirements/:id (read-only detail + komentáře).
            // {path: '/service-requirements/:id', name: 'ServiceRequirementsDetail', component: ServiceRequirements, meta: {title: 'Servisní požadavky'}},
            {path: '/my-service-requirements', name: 'ClientServiceRequirementsIndex', component: ClientServiceRequirementsIndex, meta: {title: 'Servisní centrum'}},
            {path: '/my-service-requirements/:id', name: 'ClientServiceRequirementDetail', component: ClientServiceRequirementDetail, meta: {title: 'Detail servisního požadavku'}},
            {path: '/back-office/service-requirements/history', name: 'BackOfficeServiceRequirementsHistory', component: ServiceRequirementsHistory, meta: {title: 'Historie servisních požadavků'}},
            {path: '/back-office/service-requirements', name: 'BackOfficeServiceRequirementsIndex', component: BackOfficeServiceRequirementsIndex, meta: {title: 'Servisní centrum'}},
            {path: '/back-office/service-requirements/:id', name: 'BackOfficeServiceRequirementDetail', component: ServiceRequirementDetail, meta: {title: 'Detail servisního požadavku'}},
            {path: '/advisor/service-requirements', name: 'AdvisorServiceRequirementsIndex', component: AdvisorServiceRequirementsIndex, meta: {title: 'Servisní centrum'}},
            {path: '/advisor/service-requirements/:id', name: 'AdvisorServiceRequirementDetail', component: ClientServiceRequirementDetail, meta: {title: 'Detail servisního požadavku'}},
            {path: '/contract-strategy/:id', name: 'ContractStrategyOverview', component: ContractStrategyOverview, meta: {title: 'Detail strategie'}},
            {path: '/contract/:id', name: 'ContractOverview', component: ContractOverview, meta: {title: 'Detail investice'}},
            {path: '/settings', name: 'Settings', component: Settings, meta: {title: 'Nastavení'}},
            {path: '/notification-settings', name: 'NotificationSettings', component: NotificationSettings, meta: {title: 'Nastavení notifikací', requiresAuth: true}},
            {path: '/my-documents', name: 'MyDocuments', component: MyDocuments, meta: {title: 'Moje dokumenty'}},
            {path: '/notifications', name: 'Notifications', component: Notifications, meta: {title: 'Notifikace'}},
            {path: '/clients', name: 'Clients', component: ClientsIndex, meta: {title: 'Klient', requiresAuth: true}},
            {path: '/clients/archive', name: 'ClientsArchive', component: ClientsArchive, meta: {title: 'Archiv klientů', requiresAuth: true}},
            {path: '/clients/:id/detail', name: 'ClientDetail', component: ClientsDetail, meta: {title: 'Detail klienta', requiresAuth: true}},
            {path: '/contract-types', name: 'ContractTypes', component: ContractTypesIndex, meta: {title: 'Typy smluv', requiresAuth: true}},
            {path: '/contract-types/:id/detail', name: 'ContractTypeDetail', component: ContractTypesDetail, meta: {title: 'Detail typu smlouvy', requiresAuth: true}},
            {path: '/documents/templates', name: 'DocumentTemplates', component: DocumentTemplatesIndex, meta: {title: 'Šablony dokumentů', requiresAuth: true}},
            {path: '/documents/templates/categories', name: 'DocumentTemplateCategories', component: DocumentTemplateCategoriesIndex, meta: {title: 'Kategorie', requiresAuth: true}},
            {path: '/documents/templates/:id/preview', name: 'DocumentTemplatePreview', component: PdfViewer, meta: {title: 'Zobrazení šablony', requiresAuth: true}},
            {path: '/documents/templates/:id/detail', name: 'DocumentTemplateDetail', component: DocumentTemplateDetail, meta: {title: 'Detail šablony', requiresAuth: true}},
            {path: '/documents', name: 'Documents', component: DocumentsIndex, meta: {title: 'Dokumenty', requiresAuth: true}},
            {path: '/documents/:id/detail', name: 'DocumentDetail', component: DocumentsDetail, meta: {title: 'Detail dokumentu', requiresAuth: true}},
            {path: '/documents/:id/detail/simple', name: 'DocumentDetailSimple', component: DocumentsDetailSimple, meta: {title: 'Detail dokumentu', requiresAuth: true}},
            {path: '/documents/preview/:uuid', name: 'PDFViewer', component: PdfViewer, meta: {title: 'Náhled dokumentu', requiresAuth: true}},
            {path: '/intermediaries', name: 'Intermediaries', component: IntermediariesIndex, meta: {title: 'Zprostředkovatelé', requiresAuth: true}},
            {path: '/intermediaries/:id/detail', name: 'IntermediaryDetail', component: IntermediariesDetail, meta: {title: 'Detail zprostředkovatele', requiresAuth: true}},
            {path: '/reports', name: 'ReportsIndex', component: ReportsIndex, meta: {title: 'Reporty', requiresAuth: true}},
            {path: '/intermediary-people', name: 'IntermediaryPeople', component: IntermediaryPeopleIndex, meta: {title: 'Zástupci zprostředkovatelů', requiresAuth: true}},
            {path: '/intermediary-people/:id/detail', name: 'IntermediaryPersonDetail', component: IntermediaryPeopleDetail, meta: {title: 'Detail zástupce zprostředkovatele', requiresAuth: true}},
            {path: '/my-advisors', name: 'MyAdvisors', component: MyAdvisorsIndex, meta: {title: 'Moji poradci', requiresAuth: true}},
            {path: '/strategies', name: 'Strategies', component: StrategiesIndex, meta: {title: 'Strategie', requiresAuth: true}},
            {path: '/strategies/:id/detail', name: 'StrategyDetail', component: StrategiesDetail, meta: {title: 'Detail strategie', requiresAuth: true}},
            // IMA-517: Dluhopisy v administraci (dřív „Cenné papíry“ – adresa a názvy route zůstaly kvůli uloženým odkazům)
            {path: '/securities', name: 'Securities', component: BondsIndex, meta: {title: 'Dluhopisy', requiresAuth: true}},
            {path: '/securities/:id/detail', name: 'SecurityDetail', component: BondsDetail, meta: {title: 'Detail dluhopisu', requiresAuth: true}},
            // IMA-517 fáze 6: Dluhopisy klienta (BE vrací data jen přihlášenému klientovi)
            {path: '/bonds', name: 'ClientBonds', component: ClientBondsIndex, meta: {title: 'Dluhopisy', requiresAuth: true}},
            {path: '/bonds/:id', name: 'ClientBondDetail', component: ClientBondDetail, meta: {title: 'Detail dluhopisu', requiresAuth: true}},
            // IMA-517 fáze 7: Dluhopisy poradce (nabízené dluhopisy); detail sdílí stránku s klientem přes meta.advisor
            {path: '/advisor/bonds', name: 'AdvisorBonds', component: AdvisorBondsIndex, meta: {title: 'Dluhopisy', requiresAuth: true}},
            {path: '/advisor/bonds/:id', name: 'AdvisorBondDetail', component: ClientBondDetail, meta: {title: 'Detail dluhopisu', requiresAuth: true, advisor: true}},
            {path: '/forms/templates', name: 'FormsTemplates', component: FormsTemplatesIndex, meta: {title: 'Šablony formulářů', requiresAuth: true}},
            {path: '/files/:id/detail', name: 'FileDetail', component: FileDetail, meta: {title: 'Náhled souboru', requiresAuth: true}},
            {path: '/users', name: 'Users', component: UsersIndex, meta: {title: 'Uživatel', requiresAuth: true}},
            {path: '/users/:id/detail', name: 'UserDetail', component: UsersDetail, meta: {title: 'Detail uživatele', requiresAuth: true}},
            {path: '/payment-terms', name: 'PaymentTerms', component: PaymentTerms, meta: {title: 'Platební údaje', requiresAuth: true}},
            {path: '/upload-reports', name: 'UploadReports', component: BatchesIndex, meta: {title: 'Nahrávání reportů', requiresAuth: true}},
            {path: '/batches/:id', name: 'BatchDetail', component: BatchesDetail, meta: {title: 'Detail dávky', requiresAuth: true}},
            {path: '/:pathMatch(.*)*', name: 'NotFound', component: Page404},
        ],
    },
    {
        path: '/auth',
        redirect: '/login',
        name: 'Auth',
        component: AuthLayout,
        children: [
            {path: '/login', name: 'Login', component: Login},
            {path: '/forgotten-password', name: 'ForgottenPassword', component: ForgottenPassword},
            {path: '/reset-password', name: 'ResetPassword', component: ResetPassword},
            {path: '/activation', name: 'Activation', component: Activation},
            {path: '/self-register', name: 'SelfRegister', component: SelfRegister},
            {path: '/self-register-embedded', name: 'SelfRegisterEmbedded', component: SelfRegister},
        ],
    },
    /*{
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: Page404,
    },*/
];

const router = createRouter({
    history: createWebHistory(getFrontendBase()),
    routes,
});

export const publicRoutes = ['/login', '/activation', '/forgotten-password', '/reset-password', '/self-register', '/self-register-embedded'];

// // Update the document title on each route change
// router.beforeEach((to, from, next) => {

//     const toDepth = to.path.split('/').filter(Boolean).length
//     const fromDepth = from.path.split('/').filter(Boolean).length
//     to.meta.transition = toDepth < fromDepth ? 'slide-right' : 'slide-left'

//     if (!publicRoutes.includes(to.name) && !localStorage.getItem('ACCESS_TOKEN')) {
//         sessionStorage.setItem('REDIRECT_AFTER_LOGIN', window.location.href);
//         return next({name: 'Login'});
//     }
//     if (publicRoutes.includes(to.name) && localStorage.getItem('ACCESS_TOKEN')) {
//         // if it is bank id login, do not redirect to dashboard
//         if (!window.location.href.includes('code=') && !window.location.href.includes('state=')) {
//             return next({name: 'Dashboard'});
//         }
//     }
//     document.title = to.meta.title || 'In Equity';
//     return next();
// });
router.beforeEach((to, from, next) => {
    if (to.query.access_token) {
        localStorage.setItem('ACCESS_TOKEN', to.query.access_token);
        const query = {...to.query};
        delete query.access_token;
        return next({path: to.path, query});
    }

    const isPublic = publicRoutes.includes(to.path);
    const isLogged = !!localStorage.getItem('ACCESS_TOKEN');

    if (!isPublic && !isLogged) {
        sessionStorage.setItem('REDIRECT_AFTER_LOGIN', window.location.href);
        return next({name: 'Login'});
    }

    if (isPublic && isLogged) {
        const hasOauthParams = window.location.href.includes('code=') || window.location.href.includes('state=');
        if (!hasOauthParams) return next({name: 'Dashboard'});
    }

    // Transition dopředu (ne v afterEach)
    const seg = p => p.split('/').filter(Boolean).length;
    const toDepth = seg(to.path);
    const fromDepth = seg(from.path || '');
    to.meta.transition = toDepth < fromDepth ? 'slide-right' : 'slide-left';

    const appName = window.location.hostname.includes('biginvest') ? 'B.I.G. Invest' : 'In Equity';
    document.title = to.meta.title || appName;
    return next();
});


export default router;
